import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { STAR_MSG } from "./actionTypes";
import { starMsgError, starredMsg } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* starMsg({ payload: { chatId, msgId, starred } }) {
  try {
    const response = yield call(
      axios.patch,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/message/favorite/${msgId}`,
      { favorite: starred }
    );

    if (response.status === 200) {
      yield put(starredMsg({ chatId: chatId, msgId: msgId, starred: starred }));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Star message error";
    yield put(starMsgError({ action: "star_message", message: message }));
  }
}

export function* watchStarMsg() {
  yield takeEvery(STAR_MSG, starMsg);
}
function* authSaga() {
  yield all([fork(watchStarMsg)]);
}

export default authSaga;
